import { render, staticRenderFns } from "./index.vue?vue&type=template&id=175cf8a2"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {MediasPicture: require('/vercel/path0/components/elements/Medias/Picture.vue').default,MediasVideo: require('/vercel/path0/components/elements/Medias/Video.vue').default})
